const dummyTracks = [
    {
      id: 1,
      title: "Starboy",
      artistName: "The Weeknd",
      duration: "4:16",
      thumbnail: require('../assets/starboy.jpg'),
      musicUrl: "/demons.mp3",
      dominantColor: "#1E1E1E",
      album: "Starboy"
    },
    {
      id: 2,
      title: "Demons",
      artistName: "Imagine Dragons",
      duration: "5:24",
      thumbnail: require('../assets/demons.jpg'),
      musicUrl: "/demons.mp3",
      dominantColor: "#2D2D2D",
      album: "Night Visions"
    },
    {
      id: 3,
      title: "Mouth of the river",
      artistName: "Imagine Dragons",
      duration: "6:23",
      thumbnail: require('../assets/mouth-of-the-river.jpg'),
      musicUrl: "/demons.mp3",
      dominantColor: "#1A1A1A",
      album: "Evolve"
    },
    {
      id: 4,
      title: "Ghost Stories",
      artistName: "Coldplay",
      duration: "3:10",
      thumbnail: require('../assets/ghost-stories.jpg'),
      musicUrl: "/demons.mp3",
      dominantColor: "#2A2A2A",
      album: "Ghost Stories"
    },
    {
      id: 5,
      title: "Sparks",
      artistName: "Coldplay",
      duration: "4:23",
      thumbnail: require('../assets/sparks.jpg'),
      musicUrl: "/demons.mp3",
      dominantColor: "#333333",
      album: "Parachutes"
    },
    {
      id: 6,
      title: "Viva La Vida",
      artistName: "Coldplay",
      duration: "5:32",
      thumbnail: require('../assets/viva-la-vida.jpg'),
      musicUrl: "/demons.mp3",
      dominantColor: "#1F1F1F",
      album: "Viva la Vida"
    },
    {
      id: 7,
      title: "Hymn for the Weekend",
      artistName: "Coldplay",
      duration: "4:18",
      thumbnail: require('../assets/hymn-for-the-weekend.jpg'),
      musicUrl: "/demons.mp3",
      dominantColor: "#252525",
      album: "A Head Full of Dreams"
    }
  ];
  
  export default dummyTracks;